import "core-js/modules/es.array.map";
import "core-js/modules/es.function.name";
import _taggedTemplateLiteral from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createClass";
import _createSuper from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/createSuper";
import _inherits from "/home/cooper/dev/qikan/dingkan_admin/node_modules/@babel/runtime/helpers/esm/inherits";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n        query {\n          getNewOrders {\n            order\n            refund\n            refundApplication\n            refundAudit\n          }\n        }\n      "]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import { __decorate } from "tslib";
import { Component } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';
import moment from 'moment';
import AppDialog from './AppDialog.vue';
import AuthFilter from '@/mixins/auth-filter';
import { dispatchClearPage, dispatchUpdateIfNewOrders } from '@/store/dispatches';
import gql from 'graphql-tag';
import { State } from 'vuex-class';

var AppDrawer = /*#__PURE__*/function (_mixins) {
  _inherits(AppDrawer, _mixins);

  var _super = _createSuper(AppDrawer);

  function AppDrawer() {
    var _this;

    _classCallCheck(this, AppDrawer);

    _this = _super.apply(this, arguments);
    _this.drawer = null;
    _this.items = [{
      title: '商品管理',
      icon: require('@/assets/icon_menu_book.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [{
        title: '商品品类',
        routeTo: 'GoodsList',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }]
    }, {
      title: '订单管理',
      icon: require('@/assets/icon_menu_order.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [{
        title: '订单',
        routeTo: 'OrderList',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }, {
        title: '申请退款订单',
        routeTo: 'RefundOrder',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }, {
        title: '线上退款审核',
        routeTo: 'RefundAudit',
        role: ['ROOT', 'ADMIN']
      }, {
        title: '退款单',
        routeTo: 'RefundList',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }, {
        title: '佣金管理',
        routeTo: 'ProfitSharingsList',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }]
    }, {
      title: '学校管理',
      icon: require('@/assets/icon_menu_school.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [{
        title: '学校',
        routeTo: 'SchoolList',
        role: ['ROOT', 'ADMIN', 'DEALER']
      }]
    }, {
      title: '经销商管理',
      icon: require('@/assets/icon_menu_dealer.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [{
        title: '经销商',
        role: ['ROOT', 'ADMIN', 'DEALER'],
        routeTo: 'DealerList'
      }]
    }, {
      title: '会员管理',
      icon: require('@/assets/icon_menu_device.png'),
      role: ['ROOT', 'ADMIN'],
      subList: [{
        title: '会员',
        role: ['ROOT', 'ADMIN'],
        routeTo: 'MemberList'
      }]
    }, {
      title: '设置',
      icon: require('@/assets/icon_menu_gear.png'),
      role: ['ROOT', 'ADMIN', 'DEALER'],
      subList: [{
        title: '修改密码',
        role: ['ROOT', 'ADMIN', 'DEALER'],
        routeTo: 'ChangePassword'
      }, {
        title: '管理员列表',
        role: ['ROOT', 'ADMIN'],
        routeTo: 'ManagerList'
      }, {
        title: '征订周期',
        role: ['ROOT', 'ADMIN'],
        routeTo: 'SubscriptionCycle'
      }]
    }];
    _this.subItems = [];
    _this.current = -1;
    _this.menuMap = {};
    _this.folded = false;
    _this.subListShow = false;
    _this.subListPos = {
      x: 0,
      y: 0
    };
    return _this;
  }

  _createClass(AppDrawer, [{
    key: "mounted",
    value: function mounted() {
      var _this2 = this;

      this.getOrderViewHistory();
      var start = 0;
      var end = -1;
      var routeMap = {};
      var items = this.items.map(function (item, index) {
        end += 1;
        start = end;

        if (item.subList) {
          var subList = item.subList.map(function (sItem) {
            end += 1;
            routeMap[sItem.routeTo] = {
              parentIndex: index,
              totalIndex: end
            };
            return Object.assign({}, sItem, {
              active: end
            });
          });
          item.subList = subList;
        } else {
          routeMap[item.routeTo] = {
            parentIndex: index,
            totalIndex: start
          };
        }

        _this2.menuMap[item.title] = {
          s: start,
          e: end
        };
        return Object.assign({}, item, {
          active: start
        });
      });
      this.items = items;
      var routeName = this.$route.name;
      this.current = routeMap[routeName] ? routeMap[routeName].totalIndex : 1;
      var parentIndex = routeMap[routeName] ? routeMap[routeName].parentIndex : 0;
      this.handleClick(items[parentIndex], parentIndex);
    }
  }, {
    key: "fold",
    value: function fold() {
      this.folded = !this.folded;
      this.subItems = [];
    }
  }, {
    key: "routeTo",
    value: function routeTo(routeName) {
      var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      dispatchClearPage(this.$route.name);

      if (routeName === this.$route.name) {
        return;
      }

      this.$router.push({
        name: routeName,
        params: params
      }).catch(function (err) {
        return err;
      });
    }
  }, {
    key: "handleClick",
    value: function handleClick(item, index) {
      var menuList = this.$refs.menuList;

      if (!menuList) {
        return;
      }

      var pos = menuList[index].getBoundingClientRect();

      if (item.active === this.current) {
        this.subListShow = false;
        this.subItems = [];
        this.subListPos = {
          x: 0,
          y: 0
        };
        this.current = -1;
      } else {
        this.subListPos.x = 66;
        this.subListPos.y = pos.y;
        this.subItems = item.subList;
        this.subListShow = true;
        this.current = item.active;
      }
    }
  }, {
    key: "handleClickSubItem",
    value: function handleClickSubItem(subItem) {
      this.current = subItem.active;
      this.routeTo(subItem.routeTo);
      this.subItems = [];
    }
  }, {
    key: "utcDateTimeToLocal",
    value: function utcDateTimeToLocal(date) {
      return moment.utc(date).local().format('D-M-YYYY H:mm');
    }
  }, {
    key: "getOrderViewHistory",
    value: function () {
      var _getOrderViewHistory = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var result;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.$apollo.query({
                  query: gql(_templateObject())
                });

              case 2:
                result = _context.sent;

                if (result) {
                  dispatchUpdateIfNewOrders(result.data.getNewOrders);
                }

              case 4:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function getOrderViewHistory() {
        return _getOrderViewHistory.apply(this, arguments);
      }

      return getOrderViewHistory;
    }()
  }, {
    key: "showRedDot",
    value: function showRedDot(item) {
      var _this$ifNewOrders = this.ifNewOrders,
          order = _this$ifNewOrders.order,
          refund = _this$ifNewOrders.refund,
          refundApplication = _this$ifNewOrders.refundApplication,
          refundAudit = _this$ifNewOrders.refundAudit;
      var routeTo = item.routeTo;

      if (routeTo === 'OrderList' && order) {
        return true;
      }

      if (routeTo === 'RefundOrder' && refundApplication) {
        return true;
      }

      if (routeTo === 'RefundAudit' && refundAudit) {
        return true;
      }

      if (routeTo === 'RefundList' && refund) {
        return true;
      }

      return false;
    }
  }]);

  return AppDrawer;
}(mixins(AuthFilter));

__decorate([State(function (state) {
  return state.snacks.ifNewOrders;
})], AppDrawer.prototype, "ifNewOrders", void 0);

AppDrawer = __decorate([Component({
  components: {
    AppDialog: AppDialog
  }
})], AppDrawer);
export default AppDrawer;